import CustomerUsageDashboardReducer from './CustomerUsageDashboardReducer';
import { CustomerUsageDashboardProjectsReducers } from './containers/CustomerUsageDashboardProjects';

export default from './CustomerUsageDashboardContainer';
export const CustomerUsageDashboardReducers = {
  CustomerUsageDashboardReducer,
  ...CustomerUsageDashboardProjectsReducers,
};
